import {Component, Input} from '@angular/core';

@Component({
	selector: 'table-placeholder',
	styles: ['.ph-item > .ph-col-4 {margin-top: 10px; margin-bottom: 10px;}'],
	template: `
		<div class="ph-item">
			<div class="ph-col-4">
				<div class="ph-row">
					<div class="ph-col-12 big"></div>
				</div>
			</div>
			<div class="ph-col-4">
				<div class="ph-row">
					<div class="ph-col-12 big"></div>
				</div>
			</div>
			<div class="ph-col-4">
				<div class="ph-row">
					<div class="ph-col-12 big"></div>
				</div>
			</div>
			<ng-container *ngFor="let index of rows | ngForTimes">
				<div class="ph-col-4">
					<div class="ph-row">
						<div class="ph-col-12"></div>
					</div>
				</div>
				<div class="ph-col-4">
					<div class="ph-row">
						<div class="ph-col-12"></div>
					</div>
				</div>
				<div class="ph-col-4">
					<div class="ph-row" *ngIf="buttons">
						<div class="ph-col-2 empty"></div>
						<div class="ph-col-4"></div>
						<div class="ph-col-2 empty"></div>
						<div class="ph-col-4"></div>
					</div>
					<div class="ph-row" *ngIf="!buttons">
						<div class="ph-col-12"></div>
					</div>
				</div>
			</ng-container>
		</div>
	`,
})
export class TablePlaceholderComponent {
	@Input() public buttons = false;
	@Input() public rows: number = 3;
}
